import HiveFlowLoader from "@/components/HiveFlowLoader";

export default function SplashScreen() {
  return <HiveFlowLoader fullScreen label="Bijen App laden" sublabel="Je sessie controleren" />;
}
